export default {
  title: 'ชำระค่าจอดรถ',
  checked_in_at: 'เข้าจอดเมื่อ {{time}}',
  checked_in_subtitle: 'จอดรถและออกเมื่อพร้อม',
  tap_to_refresh: 'แตะเพื่อตรวจสอบสถานะ',
  scan_qr_to_pay: 'สแกนเพื่อชำระเงิน',
  scan_dynamic_qr: 'สแกนเพื่อชำระเงินด้วย พร้อมเพย์',
  reference_label: 'อ้างอิง',
  charge_amount: 'ยอดชำระ: ฿{{amount}}',
  upload_slip: 'อัปโหลดสลิปการชำระเงิน',
  tap_to_upload: 'แตะเพื่อเลือกรูปสลิป',
  submit_slip: 'ส่งสลิป',
  waiting_title: 'ส่งสลิปแล้ว',
  waiting_subtitle: 'กำลังตรวจสอบสลิป หน้านี้จะอัปเดตอัตโนมัติ',
  upload_new_slip: 'อัปโหลดสลิปใหม่',
  rejected_title: 'สลิปไม่ผ่านการตรวจสอบ',
  rejected_reason: 'เหตุผล: {{reason}}',
  rejected_plate: 'ทะเบียน {{plate}}',
  rejected_resubmit: 'ส่งสลิปใหม่',
  rejected_contact_staff: 'หรือติดต่อเจ้าหน้าที่ที่ป้อมยาม',
  contact_staff_title: 'ติดต่อเจ้าหน้าที่ที่ป้อมยาม',
  contact_staff_subtitle: 'เจ้าหน้าที่จะช่วยดำเนินการชำระค่าจอดรถให้',
  overstay_title: 'กรุณาติดต่อเจ้าหน้าที่เพื่อออกจากที่จอด',
  overstay_subtitle: 'รถของคุณจอดเกินช่วงเวลาชำระเงินอัตโนมัติแล้ว เจ้าหน้าที่จะช่วยดำเนินการชำระเงิน',
  paid_title: 'ยืนยันการชำระแล้ว',
  paid_subtitle: 'ยืนยันเมื่อ {{time}} ขับรถปลอดภัย!',
  errors: {
    invalid_token: 'ลิงก์ชำระเงินไม่ถูกต้องหรือหมดอายุ',
    load_failed: 'โหลดข้อมูลไม่สำเร็จ กรุณาลองอีกครั้ง',
    upload_failed: 'อัปโหลดไม่สำเร็จ กรุณาลองอีกครั้ง',
    no_file: 'กรุณาเลือกรูปภาพ',
  },
}
